const roleToUrl = (role: string) => {
  switch (role) {
    case "ADMIN":
      return "/panel/administrator";
    // case "GOVERNMENTSHIP":
    //   return "/panel/government-ship/dashboard";
    // case "PROVINCE_EDUCATION":
    //   return "/panel/province-education/dashboard";
    // case "SUPER_AGENT_SCHOOL":
    //   return "/panel/super-agent/dashboard";
    case "MUNICIPALITY":
      return "/panel/municipality";
    case "COMPANY":
      return "/panel/company";
    default:
      return "/panel/404";
  }
};
export default roleToUrl;
